export const transferLoaders = {
"hausmeister-manager": () => import("./hausmeister-manager/transferAdapters.ts"),
"hausmeister-worker": () => import("./hausmeister-worker/transferAdapters.ts"),
"vorgang": () => import("./vorgang/transferAdapters.ts"),
};

